<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';
    import { Link } from '@inertiajs/vue3';
    import { CardTitle } from '@/components/ui/card';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
        href: string;
        isActive?: boolean;
    }>();
</script>

<template>
    <button
        as-child
        :class="
            cn(
                'flex h-7.5 items-center border-b-2 border-transparent opacity-50 transition-colors',
                isActive && 'border-foreground opacity-100',
                props.class,
            )
        "
    >
        <Link :href="href">
            <CardTitle :class="isActive ? 'font-bold' : 'font-normal'">
                <slot />
            </CardTitle>
        </Link>
    </button>
</template>
